<div class="contents-area">
  <div class="element-column">
    <button id="btn_Search" #btn_Search class="btn-secondary" [autofocus]="true" (click)="eventClickHandler_Search()"
      forcedEnabledMode="true" [tabindex]="0">画像検索</button>
    <div class="column-list">
      <label class="list-input-title">出力帳票選択</label>
      <div class="list-input-content">
        <app-code-combo-box id="cmb_OutputFileSelection" #cmb_OutputFileSelection [tabindex]="0" [style.width.px]="200"
          (change)="eventChangeHandler_OutputFile()" [codeDiv]="'ctp351'"
          [labelField]="'codeValueName'"></app-code-combo-box>
        <button id="btn_OutputFile" #btn_OutputFile [tabindex]="0" class="btn-secondary"
          (click)="eventClickHandler_OutputFile()">帳票出力</button>
      </div>
    </div>
  </div>
  <div style="width: 1623px;">
    <h1>画像ファイル一覧</h1>
    <div>
      <div class="action-area">
        <div class="guide-label">
          <label class="deactivated-image">使用停止画像</label>
        </div>
        <div class="column-list">
          <label class="list-input-title">表示モード</label>
          <div class="list-input-content" id="grp_Mode">
            <app-radio-label [name]="'grp_Mode'" label="通常モード" id="rdb_NormalMode" #rdb_NormalMode
              [subid]="'rdb_NormalMode'" [checked]="true" (change)="eventChangeHandler_Mode(0)" [tabindex]="0" value='0'
              [(ngModel)]="kymw1700Model.displayType" [disabled]="isPermissionReadonly()">
            </app-radio-label>
            <app-radio-label [name]="'grp_Mode'" label="一覧編集モード" id="rdb_EditMode" #rdb_EditMode
              [subid]="'rdb_EditMode'" [checked]="false" (change)="eventChangeHandler_Mode(1)" [tabindex]="0" value='1'
              [(ngModel)]="kymw1700Model.displayType" [disabled]="isPermissionReadonly()">
            </app-radio-label>
          </div>
        </div>
      </div>

      <!-- データグリッド定義(画像ファイル一覧) -->
      <wj-flex-grid #dtg_ImageInfo [itemsSource]="kymw1700Model.imageInfoList" id="dtg_ImageInfo"
        [headersVisibility]="'Column'" [frozenColumns]="11" [selectionMode]="'ListBox'" [isReadOnly]="true"
        [allowDragging]="'None'" [tabindex]="0"
        (initialized)="initMain(dtg_ImageInfo)" >
        <wj-flex-grid-filter #fltr_Main></wj-flex-grid-filter>
        <wj-flex-grid-column [minWidth]="5" [width]="50" [binding]="'checked'" [align]="'center'" [isReadOnly]="true"
          [allowSorting]="false">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="checkbox" [(ngModel)]="cell.item.checked" [tabindex]="0" id="cb_{{cell.row.index}}"
              (mouseup)="$event.stopPropagation()" />
          </ng-template>
          <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
            <div>
              <input type="checkbox" id="chk_AllChecked" #chk_AllChecked forcedEnabledMode="true" [tabindex]="0"
                (change)="eventClickHandler_CheckToggleAll()" class="headear-checkbox" />
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="90"
          [header]="'使用開始\n受注コード'" [binding]="'startOrderCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="140"
          [header]="'使用開始\n配達企画回(翌週)'" [binding]="'startDelivCatalogId'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="115"
          [header]="'ステータス'" [binding]="'statusName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="106"
          [header]="'部門'" [binding]="'className'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="82"
          [header]="'Ｐコード'" [binding]="'pcode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="150"
          [header]="'商品案内用商品名'" [binding]="'guideGoodsName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="150"
          [header]="'商品案内用規格名'" [binding]="'guideStandardName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="118"
          [header]="'画像ファイル名'" [binding]="'imageFileName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="70"
          [header]="'C2PF\n対象'" [binding]="'c2pfTarget'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 2; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <select (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)" forcedEnabledMode="true">
              </select>
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.c2pfTarget }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="126"
          [header]="'画像種類'" [binding]="'imageKindName'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <app-versatile-combo-box
                [listSource]="kymw1700Model.imageKindList" valueField="CodeValue" labelField="CodeName" forcedEnabledMode="true" [tabindex]="0" [dspBothField]="true"
                [(ngModel)]="cell.item.imageKind" (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)"
                [style.width.%]="'100'">
              </app-versatile-combo-box>
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.imageKind }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'画像使用方法'" [binding]="'imageUseMethodName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="110"
          [header]="'撮影No'" [binding]="'photographingNo'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text" plessInputTextSub [(ngModel)]="cell.item.photographingNo" [style.width.%]="100"
                [required]="true" [restrict]="'[a-zA-Z0-9]'"
                (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)" [maxlength]="10" [halfOnly]="true" />
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.photographingNo }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="50" [header]="'月'"
          [binding]="'delivCatalogMonth'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="50" [header]="'回'"
          [binding]="'delivCatalogTime'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="60" [header]="'包材'"
          [binding]="'packaging'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="58" [header]="'盛り'"
          [binding]="'plating'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="72" [header]="'調理要'"
          [binding]="'cookNecessary'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="60" [header]="'調理\n不要'"
          [binding]="'cookUnnecessary'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="60" [header]="'説明\n素材'"
          [binding]="'explain'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="70" [header]="'その他'"
          [binding]="'other'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="60" [header]="'裏面'"
          [binding]="'backSide'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="70" [header]="'温度帯'"
          [binding]="'tempRangeName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'複数コード登録'" [binding]="'multipleCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'過去画像情報'" [binding]="'pastImageInfo'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'撮影注意事項'" [binding]="'imageCaution'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="224"
          [header]="'撮影指示内容'" [binding]="'photoContentsName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'参考資料点数'" [binding]="'referenceImageNum'" [align]="'right'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="135"
          [header]="'請求先名'" [binding]="'billingName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="190"
          [header]="'C2PF\nステータス'" [binding]="'c2pfStatusName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'遅延フラグ'" [binding]="'delayFlag'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'取引先コメント'" [binding]="'supplierInfo'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="300"
          [header]="'取引先への\n連絡事項'" [binding]="'supplierAnnouncement'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text" plessInputTextSub [(ngModel)]="cell.item.supplierAnnouncement" [style.width.%]="100"
                [required]="true" [restrict]="'[ -￮]'" [maxlength]="128"
                (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)" />
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.supplierAnnouncement }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="180"
          [header]="'ステータス\n差し戻し理由'" [binding]="'statusRemandReason'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="300" [header]="'変更'"
          [binding]="'imageInfoChange'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text" plessInputTextSub [(ngModel)]="cell.item.imageInfoChange" [style.width.%]="100"
                [required]="true" [restrict]="'[ -￮]'" [maxlength]="128"
                (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)" />
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.imageInfoChange }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="300" [header]="'備考'"
          [binding]="'remarks'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text" plessInputTextSub [(ngModel)]="cell.item.remarks" [style.width.%]="100"
                [required]="true" [restrict]="'[ -￮]'" [maxlength]="128"
                (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)" />
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.remarks }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="150"
          [header]="'撮影予定日'" [binding]="'photoSchedule'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <wj-input-date format="yyyy/MM/dd" [(ngModel)]="cell.item.datePhotoSchedule" forcedEnabledMode="true" #photoSchedule
                [(text)]="cell.item.photoSchedule" [tabindex]="0" [style.width.%]="100"
                (ngModelChange)="eventChangeHandler_ScheduleDate(cell.row.index, photoSchedule)">
              </wj-input-date>
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.photoSchedule }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="150"
          [header]="'変更前\n撮影予定日'" [binding]="'photographingChangeSchedule'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <wj-input-date format="yyyy/MM/dd" [(ngModel)]="cell.item.datePhotographingChangeSchedule" forcedEnabledMode="true" #photographingChangeSchedule
                [(text)]="cell.item.photographingChangeSchedule" [tabindex]="0" [style.width.%]="100"
                (ngModelChange)="eventChangeHandler_ScheduleDate(cell.row.index, photographingChangeSchedule)">
              </wj-input-date>
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.photographingChangeSchedule }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="300" [header]="'繰越'"
          [binding]="'carriedForward'">
          <!-- modeが1ならテキスト入力、0ならテキスト表示 -->
          <ng-container *ngIf="kymw1700Model.mode === 1; else textDisplay">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text" plessInputTextSub [(ngModel)]="cell.item.carriedForward" [style.width.%]="100"
                [required]="true" [restrict]="'[ -￮]'" [maxlength]="128"
                (change)="eventChangeHandler_DtgImageInfoCell(cell.row.index)" />
            </ng-template>
          </ng-container>
          <ng-template #textDisplay>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span>{{ cell.item.carriedForward }}</span>
            </ng-template>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="128"
          [header]="'起票日\n（作成指示日）'" [binding]="'imageInstructDate'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'起票者'" [binding]="'imageInstructUser'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'バイヤー名'" [binding]="'buyerName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="165"
          [header]="'C2PF更新日時'" [binding]="'c2pfUpdateDate'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="165"
          [header]="'PEACE更新日時'" [binding]="'peaceUpdateDate'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="160"
          [header]="'出力日時'" [binding]="'printDate'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="190"
          [header]="'撮影場所'" [binding]="'photoStudio'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="130"
          [header]="'JANコード'" [binding]="'janCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="100"
          [header]="'グループNo'" [binding]="'imageGroupNo'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="120"
          [header]="'小分類'" [binding]="'smallClass'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="110"
          [header]="'バイヤーコード'" [binding]="'buyerCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="105"
          [header]="'請求先コード'" [binding]="'billingCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="105"
          [header]="'サンプル発注先\nコード'" [binding]="'sampleOrderingCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="150"
          [header]="'サンプル発注先名称'" [binding]="'sampleOrderingName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="200"
          [header]="'取引先営業窓口担当者名'" [binding]="'supplierSalesStaffName'"></wj-flex-grid-column>
        <wj-flex-grid-column [allowSorting]="this.kymw1700Model.mode === 0" [minWidth]="5" [width]="209"
          [header]="'eBASE仕様書NO'" [binding]="'ebaseSpecCode'"></wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>
<footer class="footer-buttons">
  <button id="btn_Remand" #btn_Remand class="btn-tartiary" [disabled]="isPermissionReadonly()"
    (click)="eventClickHandler_Remand()" [tabindex]="0">差し戻し</button>
  <button id="btn_Save" #btn_Save class="btn-secondary" (click)="eventClickHandler_Save()" [tabindex]="0">保存
  </button>
  <button id="btn_ImageKindSync" #btn_ImageKindSync class="btn-secondary" [disabled]="isPermissionReadonly()"
    (click)="eventClickHandler_ImageKindSync()" [tabindex]="0">画像種類同期
  </button>
  <button id="btn_RegisterMultCode" #btn_RegisterMultCode class="btn-secondary" [disabled]="isPermissionReadonly()"
    (click)="eventClickHandler_RegisterMultCode()" [tabindex]="0">複数コード登録</button>
  <button id="btn_Remind" #btn_Remind class="btn-secondary" [disabled]="isPermissionReadonly()"
    (click)="eventClickHandler_Remind()" [tabindex]="0">催促</button>
  <button id="btn_RegisterPastImage" #btn_RegisterPastImage class="btn-secondary" [disabled]="isPermissionReadonly()"
    (click)="eventClickHandler_RegisterPastImage()" [tabindex]="0">過去画像登録</button>
  <button id="btn_Approval" #btn_Approval class="btn-primary" [disabled]="isPermissionReadonly()"
    (click)="eventClickHandler_Approval()" [tabindex]="0">承認</button>
</footer>